import { css } from 'particles/themes/styled'
import { theme } from 'theme'

const styles = css`
    padding: ${theme.gutter.xs} ${theme.gutter.s};
    background-color: ${theme.newColors.neutral100};
    max-width: 1920px;
    margin: 0 auto;
    .MuiDataGrid-pinnedColumns {
        box-shadow: none;
    }

    @media screen and (max-width: 768px) {
        padding-top: 0;
        .team-title {
            display: none;
        }
    }
    .tab-switcher {
        margin-bottom: 16px;
    }
    .margin-top-none {
        margin-top: 0;
    }
    .role-table {
        background-color: white;
        border-radius: 4px;
        padding: 8px;
        box-sizing: border-box;
        margin-top: 16px;
    }

    .table-button {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        gap: ${theme.newSpacing.l};
    }
`
export default styles
